import React, { useEffect } from 'react';
import { NuevaCitaPosventaFormController } from 'src/forms';
import { TriggerProps, useFaContent } from 'src/feature-app';
import { CitaPosventaCalculadoraForm, CitaPosventaBonosForm, CitaPosventaMaintenanceForm } from '../forms/CitaPosventa/CitaPosventaEmbedded';

export function CitaPosventaEmbeddedTrigger({ setSelectedJourney }: TriggerProps) {
  const faContent = useFaContent();

  switch (faContent.featureApp) {
    case 'es-calculadora':
      return <CitaPosventaCalculadoraForm setSelectedJourney={setSelectedJourney} />;
    case 'es-maintenance':
        return <CitaPosventaMaintenanceForm setSelectedJourney={setSelectedJourney} />;
    case 'es-bono':
      return <CitaPosventaBonosForm setSelectedJourney={setSelectedJourney} />;
    case 'es-mis_beneficios':
      return <NuevaCitaPosventaFormController isCitaPosventaEmbeddedBeneficios />;
  }
  return null;
}
